import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-missions',
  templateUrl: './participant-missions.component.html',
  styleUrls: ['./participant-missions.component.scss']
})
export class ParticipantMissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
